import { SITE_LOGO, SITE_NAME, type ArticleLike } from '@/lib/seo';

interface BreadcrumbItem {
  name: string;
  url: string;
}

function publisher() {
  return {
    '@type': 'Organization',
    name: SITE_NAME,
    logo: { '@type': 'ImageObject', url: SITE_LOGO },
  };
}

export function buildWebSiteSchema(url: string, lang: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url,
    inLanguage: lang,
    publisher: publisher(),
  };
}

export function buildArticleSchema(article: ArticleLike, url: string, lang: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.description,
    image: article.image,
    datePublished: article.published,
    dateModified: article.updated,
    inLanguage: lang,
    author: { '@type': 'Organization', name: article.author },
    publisher: publisher(),
    mainEntityOfPage: { '@type': 'WebPage', '@id': url },
  };
}

export function buildBreadcrumbSchema(items: BreadcrumbItem[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function injectJsonLd(id: string, schema: object) {
  const existing = document.getElementById(id);
  if (existing) existing.remove();
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.id = id;
  script.textContent = JSON.stringify(schema);
  document.head.appendChild(script);
}

export function clearJsonLd(ids: string[]) {
  ids.forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.remove();
  });
}